/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-pomodoro block)");
/* eslint-enable no-console */
(function () {

    function init() {
        const wrap = document.getElementById('pomodoroContainer');
        if (!wrap) return;

        const BEEP_BREAK = 523;
        const DEFAULT_BG = '#ffffff';

        const state = {
            work: { duration: 25 * 60, remaining: 25 * 60, running: false, interval: null },
            pause: { duration: 5 * 60, remaining: 5 * 60, running: false, interval: null }
        };

        // phase: 'idle' | 'work' | 'pause'
        // cycleRunning: true si un timer tourne ou est en pause
        let phase = 'idle';       // phase active du cycle
        let cyclePaused = false;  // le cycle est mis en pause par l'utilisateur
        let autoMode = false;
        let fsActive = false;
        let hintTimer = null;
        let audioCtx = null;
        let masterGain = null;
        let activeNode = null;
        let selectedSwatch = null;
        let cycleCount = 0;

        const el = id => wrap.querySelector('#' + id);
        const fmt = s => String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');

        function updateDisplay(type) {
            el(type + 'Display').textContent = fmt(state[type].remaining);
        }

        const setStatus = (type, t) => el(type + 'Status').textContent = t;

        function updatePageTitle() {
            const active = state.work.running ? 'work' : state.pause.running ? 'pause' : null;
            document.title = active
                ? fmt(state[active].remaining) + ' – ' + (active === 'work' ? 'Work' : 'Break') + ' | Pomodoro'
                : 'Pomodoro Focus';
        }

        // Met à jour le texte du bouton cycle unique
        function updateCycleBtn() {
            const btn = el('cycleBtn');
            if (phase === 'idle') {
                btn.textContent = 'Start';
            } else if (cyclePaused) {
                btn.textContent = 'Resume';
            } else {
                btn.textContent = 'Pause';
            }
        }

        // ── Audio ──
        function getAudio() {
            if (!audioCtx) {
                audioCtx = new (window.AudioContext || window.webkitAudioContext)();
                masterGain = audioCtx.createGain();
                masterGain.gain.value = parseFloat(el('volumeSlider').value);
                masterGain.connect(audioCtx.destination);
            }
            if (audioCtx.state === 'suspended') audioCtx.resume();
            return audioCtx;
        }

        function playBeep(freq) {
            try {
                const ctx = getAudio();
                const beepGain = ctx.createGain();
                beepGain.gain.value = 0.9;
                beepGain.connect(ctx.destination);
                for (let i = 0; i < 3; i++) {
                    const off = i * 0.5;
                    const osc = ctx.createOscillator();
                    const g = ctx.createGain();
                    osc.type = 'sine';
                    osc.frequency.value = freq;
                    osc.connect(g);
                    g.connect(beepGain);
                    g.gain.setValueAtTime(0, ctx.currentTime + off);
                    g.gain.linearRampToValueAtTime(1, ctx.currentTime + off + 0.02);
                    g.gain.setValueAtTime(1, ctx.currentTime + off + 0.26);
                    g.gain.linearRampToValueAtTime(0, ctx.currentTime + off + 0.3);
                    osc.start(ctx.currentTime + off);
                    osc.stop(ctx.currentTime + off + 0.31);
                }
            } catch (e) { console.warn('beep error', e); }
        }

        function notifyEnd(type) {
            if (!('Notification' in window)) return;
            if (Notification.permission === 'granted') {
                new Notification('Pomodoro', { body: type === 'work' ? 'Break time!' : 'Back to work!' });
            }
        }

        function requestNotifPermission() {
            if ('Notification' in window && Notification.permission === 'default') {
                Notification.requestPermission();
            }
        }

        // ── Timer interne ──
        function startTimer(type) {
            const s = state[type];
            s.running = true;
            setStatus(type, 'Running');
            updateDisplay(type);
            s.interval = setInterval(() => {
                s.remaining--;
                updateDisplay(type);
                updatePageTitle();
                if (s.remaining === 2) playBeep(BEEP_BREAK);
                if (s.remaining <= 0) {
                    clearInterval(s.interval);
                    s.running = false;
                    setStatus(type, 'Waiting');
                    updatePageTitle();
                    onEnd(type);
                }
            }, 1000);
        }

        function pauseTimer(type) {
            const s = state[type];
            if (!s.running) return;
            clearInterval(s.interval);
            s.running = false;
            setStatus(type, 'Paused');
        }

        function resumeTimer(type) {
            startTimer(type);
            setStatus(type, 'Running');
        }

        // ── Cycle ──
        function toggleCycle() {
            if (phase === 'idle') {
                phase = 'work';
                cyclePaused = false;
                if (state.work.remaining <= 0) {
                    state.work.remaining = state.work.duration;
                    updateDisplay('work');
                }
                setStatus('pause', 'Waiting');
                startTimer('work');
            } else if (!cyclePaused) {
                // Mise en pause du cycle
                cyclePaused = true;
                pauseTimer(phase);
            } else {
                // Reprise du cycle
                cyclePaused = false;
                resumeTimer(phase);
            }
            updateCycleBtn();
        }

        function resetCycle() {
            // Arrêt de tous les timers
            clearInterval(state.work.interval);
            clearInterval(state.pause.interval);
            state.work.running = false;
            state.pause.running = false;
            state.work.remaining = state.work.duration;
            state.pause.remaining = state.pause.duration;
            phase = 'idle';
            cyclePaused = false;
            cycleCount = 0;
            setStatus('work', 'Ready');
            setStatus('pause', 'Ready');
            updateDisplay('work');
            updateDisplay('pause');
            updateCycleBtn();
            updatePageTitle();
        }

        function onEnd(type) {
            notifyEnd(type);
            if (type === 'work') {
                phase = 'pause';
                // ✅ Reset du work dès qu'il arrive à 0
                state.work.remaining = state.work.duration;
                updateDisplay('work');
                state.pause.remaining = state.pause.duration;
                updateDisplay('pause');
                setStatus('work', 'Waiting');
                setTimeout(() => {
                    if (phase === 'pause' && !cyclePaused) {
                        startTimer('pause');
                        updateCycleBtn();
                    }
                }, 0);
            } else if (type === 'pause') {
                // ✅ Reset de la pause dès qu'elle arrive à 0
                state.pause.remaining = state.pause.duration;
                updateDisplay('pause');

                if (autoMode) {
                    cycleCount++;
                    const maxCycles = parseInt(el('cycleCountInput').value) || 0;
                    if (maxCycles > 0 && cycleCount >= maxCycles) {
                        phase = 'idle';
                        cyclePaused = false;
                        cycleCount = 0;
                        state.work.remaining = state.work.duration;
                        updateDisplay('work');
                        setStatus('work', 'Waiting');
                        setStatus('pause', 'Waiting');
                        updateCycleBtn();
                    } else {
                        phase = 'work';
                        state.work.remaining = state.work.duration;
                        updateDisplay('work');
                        setStatus('pause', 'Waiting');
                        setTimeout(() => {
                            if (phase === 'work' && !cyclePaused) {
                                startTimer('work');
                                updateCycleBtn();
                            }
                        }, 2100);
                    }
                } else {
                    phase = 'idle';
                    cyclePaused = false;
                    state.work.remaining = state.work.duration;
                    updateDisplay('work');
                    setStatus('pause', 'Waiting');
                    updateCycleBtn();
                }
            }
        }

        function setDurationSelect(type, val) {
            const row = el(type + 'CustomRow');
            if (val === 'custom') { row.style.display = 'flex'; return; }
            row.style.display = 'none';
            state[type].duration = parseInt(val) * 60;
            // Reset uniquement si le cycle est idle
            if (phase === 'idle') {
                state[type].remaining = state[type].duration;
                updateDisplay(type);
                setStatus(type, 'Ready');
            }
        }

        function applyCustomDuration(type) {
            const val = Math.max(1, parseInt(el(type + 'CustomInput').value) || 1);
            state[type].duration = val * 60;
            if (phase === 'idle') {
                state[type].remaining = state[type].duration;
                updateDisplay(type);
                setStatus(type, 'Ready');
            }
        }

        function toggleAutoMode() {
            autoMode = !autoMode;
            const btn = el('autoToggleBtn');
            btn.classList.toggle('active', autoMode);
            btn.textContent = 'Auto cycle: ' + (autoMode ? 'on' : 'off');
            el('cycleCountRow').style.display = autoMode ? 'flex' : 'none';
        }

        function addBonusMin() {
            state['work'].remaining += 60;
            updateDisplay('work');
            const btn = el('bonusToggleBtn');
            btn.textContent = '+1 min ✓';
            setTimeout(() => { btn.textContent = '+1 min'; }, 800);
        }

        function showHint() {
            const hint = el('fsHint');
            clearTimeout(hintTimer);
            hint.style.opacity = '1';
            hintTimer = setTimeout(() => { hint.style.opacity = '0'; }, 2500);
        }

        // ── Fullscreen ──
        const supportsFS = !!(wrap.requestFullscreen || wrap.webkitRequestFullscreen || wrap.msRequestFullscreen);

        function enterFullscreen() {
            if (supportsFS) {
                const req = wrap.requestFullscreen || wrap.webkitRequestFullscreen || wrap.msRequestFullscreen;
                req.call(wrap).catch(() => { fsActive = true; wrap.classList.add('is-fullscreen'); showHint(); });
            } else {
                fsActive = true; wrap.classList.add('is-fullscreen'); showHint();
            }
        }

        function exitFullscreen() {
            if (document.fullscreenElement || document.webkitFullscreenElement) {
                (document.exitFullscreen || document.webkitExitFullscreen).call(document);
            } else {
                fsActive = false; wrap.classList.remove('is-fullscreen');
            }
        }

        function syncFsState(isFS) {
            fsActive = isFS;
            wrap.classList.toggle('is-fullscreen', isFS);
            el('fullscreenBtn').setAttribute('aria-label', isFS ? 'Exit fullscreen' : 'Enter fullscreen');
            if (isFS) showHint();
        }

        document.addEventListener('fullscreenchange', () => syncFsState(!!document.fullscreenElement));
        document.addEventListener('webkitfullscreenchange', () => syncFsState(!!document.webkitFullscreenElement));

        // ── Listener unique ──
        wrap.addEventListener('click', function (e) {
            const btn = e.target.closest('[data-action]');
            if (btn) {
                const { action, type } = btn.dataset;
                if (action === 'cycle') { requestNotifPermission(); toggleCycle(); }
                else if (action === 'reset-cycle') resetCycle();
                else if (action === 'apply-custom') applyCustomDuration(type);
                else if (action === 'bonus') addBonusMin();
                return;
            }
            if (fsActive) exitFullscreen();
        });

        // ── Couleurs ──
        function hexToRgb(hex) {
            let h = hex.replace('#', '');
            if (h.length === 3) h = h.split('').map(c => c + c).join('');
            const n = parseInt(h, 16);
            return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
        }

        function lum({ r, g, b }) {
            return [r, g, b].reduce((acc, v, i) => {
                v /= 255;
                v = v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
                return acc + v * [0.2126, 0.7152, 0.0722][i];
            }, 0);
        }

        const isDark = hex => { try { return lum(hexToRgb(hex)) < 0.35; } catch { return false; } };

        function applyAdaptiveColors(hex) {
            const dark = isDark(hex);
            wrap.style.setProperty('--adaptive-text', dark ? '#fff' : '#000');
            wrap.style.setProperty('--adaptive-text-muted', dark ? 'rgba(255,255,255,.6)' : 'rgba(0,0,0,.55)');
            wrap.style.setProperty('--adaptive-ring-bg', dark ? 'rgba(255,255,255,.15)' : '#d8d8d8');
            wrap.style.setProperty('--select-bg', dark ? '#2a2a2a' : '#f0f0f0');
            wrap.style.setProperty('--select-text', dark ? '#fff' : '#000');
        }

        const normalizeHex = v => {
            if (!v) return null;
            v = v.trim();
            if (!v.startsWith('#')) v = '#' + v;
            return /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(v) ? v : null;
        };

        function applyBg(color, swEl) {
            const hex = normalizeHex(color) || DEFAULT_BG;
            wrap.style.setProperty('--bg-override', hex);
            wrap.style.setProperty('background-color', hex);
            el('customColor').value = hex;
            el('hexColorInput').value = hex;
            if (selectedSwatch) selectedSwatch.classList.remove('selected');
            selectedSwatch = swEl || null;
            if (swEl) swEl.classList.add('selected');
            applyAdaptiveColors(hex);
        }

        function resetBg() {
            wrap.style.setProperty('--bg-override', DEFAULT_BG);
            wrap.style.removeProperty('background-color');
            el('customColor').value = DEFAULT_BG;
            el('hexColorInput').value = DEFAULT_BG;
            if (selectedSwatch) selectedSwatch.classList.remove('selected');
            selectedSwatch = null;
            applyAdaptiveColors(DEFAULT_BG);
        }

        el('colorGrid').addEventListener('click', function (e) {
            const sw = e.target.closest('.color-swatch');
            if (sw) applyBg(sw.dataset.color, sw);
        });

        // ── Noise ──
        function bufSrc(ctx, fn) {
            const buf = ctx.createBuffer(1, ctx.sampleRate * 2, ctx.sampleRate);
            fn(buf.getChannelData(0));
            const src = ctx.createBufferSource();
            src.buffer = buf;
            src.loop = true;
            return src;
        }

        const createWhite = ctx => bufSrc(ctx, d => {
            for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
        });

        const createPink = ctx => bufSrc(ctx, d => {
            let b0 = 0, b1 = 0, b2 = 0, b3 = 0, b4 = 0, b5 = 0, b6 = 0;
            for (let i = 0; i < d.length; i++) {
                const w = Math.random() * 2 - 1;
                b0 = 0.99886 * b0 + w * 0.0555179; b1 = 0.99332 * b1 + w * 0.0750759;
                b2 = 0.969 * b2 + w * 0.153852; b3 = 0.8665 * b3 + w * 0.3104856;
                b4 = 0.55 * b4 + w * 0.5329522; b5 = -0.7616 * b5 - w * 0.016898;
                d[i] = (b0 + b1 + b2 + b3 + b4 + b5 + b6 + w * 0.5362) * 0.11;
                b6 = w * 0.115926;
            }
        });

        const createBrown = ctx => bufSrc(ctx, d => {
            let last = 0;
            for (let i = 0; i < d.length; i++) {
                const w = Math.random() * 2 - 1;
                d[i] = (last + 0.02 * w) / 1.02;
                last = d[i];
                d[i] *= 3.5;
            }
        });

        const createBlue = ctx => bufSrc(ctx, d => {
            let last = 0;
            for (let i = 0; i < d.length; i++) {
                const w = Math.random() * 2 - 1;
                d[i] = (w - last) * 0.5;
                last = w;
            }
        });

        const createViolet = ctx => bufSrc(ctx, d => {
            let last1 = 0, last2 = 0;
            for (let i = 0; i < d.length; i++) {
                const w = Math.random() * 2 - 1;
                const d1 = w - last1;
                d[i] = (d1 - last2) * 0.25;
                last2 = d1;
                last1 = w;
            }
        });

        const createOrange = ctx => bufSrc(ctx, d => {
            let b0 = 0, b1 = 0, b2 = 0, b3 = 0, b4 = 0, b5 = 0, b6 = 0, last = 0;
            for (let i = 0; i < d.length; i++) {
                const w = Math.random() * 2 - 1;
                b0 = 0.99886 * b0 + w * 0.0555179; b1 = 0.99332 * b1 + w * 0.0750759;
                b2 = 0.969 * b2 + w * 0.153852; b3 = 0.8665 * b3 + w * 0.3104856;
                b4 = 0.55 * b4 + w * 0.5329522; b5 = -0.7616 * b5 - w * 0.016898;
                const pink = (b0 + b1 + b2 + b3 + b4 + b5 + b6 + w * 0.5362) * 0.11;
                b6 = w * 0.115926;
                const brown = (last + 0.02 * w) / 1.02;
                last = brown;
                d[i] = (pink + brown * 3.5) * 0.5;
            }
        });

        const createVelvet = ctx => bufSrc(ctx, d => {
            for (let i = 0; i < d.length; i++) {
                d[i] = Math.random() < 0.01
                    ? (Math.random() < 0.5 ? 1 : -1) * (0.5 + Math.random() * 0.5)
                    : 0;
            }
        });

        function stopNoise() {
            if (activeNode) {
                try { activeNode.stop(); activeNode.disconnect(); } catch { }
                activeNode = null;
            }
        }

        function changeNoise(id) {
            stopNoise();
            if (!id) return;
            const ctx = getAudio();
            let node = null;
            let bypass = false;
            if (id === 'white') { node = createWhite(ctx); }
            else if (id === 'pink') { node = createPink(ctx); }
            else if (id === 'brown') { node = createBrown(ctx); }
            else if (id === 'blue') { node = createBlue(ctx); }
            else if (id === 'violet') { node = createViolet(ctx); }
            else if (id === 'orange') { node = createOrange(ctx); }
            else if (id === 'velvet') { node = createVelvet(ctx); }
            else if (id === 'green') {
                const s = createPink(ctx), f = ctx.createBiquadFilter();
                f.type = 'bandpass'; f.frequency.value = 800;
                s.connect(f); f.connect(masterGain);
                node = { start: () => s.start(), stop: () => { try { s.stop(); } catch { } }, disconnect: () => { try { f.disconnect(); } catch { } } };
                bypass = true;
            } else if (id === 'grey') {
                const s = createWhite(ctx), l = ctx.createBiquadFilter(), h = ctx.createBiquadFilter();
                l.type = 'lowshelf'; l.frequency.value = 200; l.gain.value = -8;
                h.type = 'highshelf'; h.frequency.value = 6000; h.gain.value = -8;
                s.connect(l); l.connect(h); h.connect(masterGain);
                node = { start: () => s.start(), stop: () => { try { s.stop(); } catch { } }, disconnect: () => { try { l.disconnect(); h.disconnect(); } catch { } } };
                bypass = true;
            } else if (id === 'red') {
                const s = createBrown(ctx), lp = ctx.createBiquadFilter();
                lp.type = 'lowpass'; lp.frequency.value = 120;
                s.connect(lp); lp.connect(masterGain);
                node = { start: () => s.start(), stop: () => { try { s.stop(); } catch { } }, disconnect: () => { try { lp.disconnect(); } catch { } } };
                bypass = true;
            }

            if (!node) return;
            if (!bypass) node.connect(masterGain);
            node.start();
            activeNode = node;
        }

        // ── Événements ──
        el('autoToggleBtn').addEventListener('click', toggleAutoMode);
        el('fullscreenBtn').addEventListener('click', function (e) {
            e.stopPropagation();
            if (fsActive) exitFullscreen(); else enterFullscreen();
        });
        el('applyHexBtn').addEventListener('click', function () {
            const h = normalizeHex(el('hexColorInput').value);
            if (h) applyBg(h, null);
        });
        el('resetBgBtn').addEventListener('click', resetBg);
        el('workSelect').addEventListener('change', function () { setDurationSelect('work', this.value); });
        el('pauseSelect').addEventListener('change', function () { setDurationSelect('pause', this.value); });
        el('noiseSelect').addEventListener('change', function () { changeNoise(this.value); });
        el('volumeSlider').addEventListener('input', function () { if (masterGain) masterGain.gain.value = parseFloat(this.value); });
        el('customColor').addEventListener('input', function () { applyBg(this.value, null); });

        // ── Init ──
        wrap.style.setProperty('--bg-override', DEFAULT_BG);
        applyAdaptiveColors(DEFAULT_BG);
        ['work', 'pause'].forEach(type => {
            const val = el(type + 'Select').value;
            if (val === 'custom') {
                el(type + 'CustomRow').style.display = 'flex';
            } else {
                const mins = parseInt(val);
                if (!isNaN(mins)) {
                    state[type].duration = mins * 60;
                    state[type].remaining = mins * 60;
                }
            }
            updateDisplay(type);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();

